import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch } from "util/router.js";
// import {loadOfferings} from 'store/actions/offeringsActions'
import {loadProducts } from 'store/actions/productActions'
import NewProductButton, {EditProductButton, DeleteProductButton} from 'components/NewProductButton';
import {Helmet} from 'react-helmet'
import Image from 'react-bootstrap/Image'
import moment from 'moment-timezone'
import ShareButton from 'components/ShareButton'

function VideoPreviewImage({width, imageUrl, className}) {

  return (
    <div className={className}>
      <div
        style={{
        borderRadius: "6px",
        overflow: "hidden",
        minWidth: `${width ?? 100}px`,
        height: "0px",
        overflow: "hidden",
        paddingTop: "56.25%",
        background: "white",
        position: "relative"}}
      >
        <div style={{
          position: "absolute",
          boxShadow: "1px 1px 0 0 #efefef",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%"}}>
            <Image 
            style={{
                width: "100%",
                height: "100%",
                objectFit: "cover", overflow: "hidden"}}
            src={imageUrl ?? "https://via.placeholder.com/1600x900.jpg"} />
        </div>
          
      </div>
    </div>
  )
}

function ProductsTable(props) {

  const products = useSelector(state => state.instructor.products.filter(val => val.location_type === "ondemand" && !val.challengeId));
  const widgetName = useSelector(state => state.instructor.instructor.widgetName)

  console.log("reload packages table")
  const tableData = products.sort((a,b) => {
    return b.created - a.created
  }).map(val => {

    let shareLink = `https://sutrapro.com/${widgetName}/on-demand/checkout/${val.platformID}`
    const preview = (
      <VideoPreviewImage width={150} imageUrl={val?.images?.length > 0 ? val.images[0] : null} />
      // <div className="d-flex d-row align-items-center">
      //   <VideoPreviewImage width={150} imageUrl={val?.images?.length > 0 ? val.images[0] : null} />
      // </div>
    )

    var status = ""
    var color = ""
    if (val.hidden) {
      // yellow "#fbeeca"
      status = "Hidden"
      color = "#6c757d"
    } else if (val.expirationDate && val.expirationDate < moment().unix()) {
      status = "Expired"
      color = "#db7f6d"
    } else {
      status = "LIVE"
      color = "#dae8cc"
    }

    const name = (
      <div className="d-flex d-row align-items-center">
        <div style={{
          backgroundColor: color,
          color: "black",
          borderRadius: "4px"
        }}
        className="px-2 py-1 mr-2"
        >
          {status}
        </div>
        <h6 className="mb-0 font-weight-bold">{val.name}</h6>
      </div>
    )

    const actions = (
      // we've added some custom button actions
      <div className="d-flex d-row justify-content-end">
          <ShareButton link={shareLink}
          style={{marginLeft: "-50px"}}
          />
          <EditProductButton 
          {...props}
          toEdit={val}
          productType="ondemand"
          />
          <DeleteProductButton 
          toDelete={val}
          productType="ondemand"
          />
      </div>
    )

    

    var categories = "None"
    if (val.categories) {
      categories = val.categories.join(", ")
    }

    var priceText = ""

    if (val.allowsDropin) {
      priceText = priceText.concat(`Buy for $${val.price}\n`)
    }

    if (val.allowsRental) {
      priceText = priceText.concat(`Rent for $${val.rentalPrice}\n`)
    }

    if (priceText === "") {
      priceText = "Subscription only"
    }

    return {
      ...val,
      name: name,
      preview: preview,
      // price: val.isSubscriptionOnly ? "Subscription" : `$${val.price}`,
      price: priceText,
      status: status,
      categories: categories,
      actions: actions
    }
  })

  return (
  <div>
      {tableData.length > 0 ? (
        <ReactTable
        data={tableData}
        filterable={false}
        columns={[
          {
            Header: "Preview",
            accessor: "preview",
            minWidth: 155
            },
            {
            Header: "Name",
            accessor: "name",
            minWidth: 150
            },
            // {
            // Header: "Hidden",
            // accessor: "sessions",
            // minWidth: 50
            // },
            {
            Header: "Created",
            accessor: "created",
            minWidth: 100,
            Cell: row => (
              <div>
                  <h6>{moment(row.value * 1000).format("dddd MMM Do")}</h6>
                  {/* <div>{moment(row.value * 1000).format("h:mm a")}</div> */}
              </div>
            ),
            },
            {
            Header: "Categories",
            accessor: "categories",
            minWidth: 200
            },
            {
            Header: "Price",
            accessor: "price",
            width: 120
            },
            // {
            // Header: "Status",
            // accessor: "status",
            // width: 100
            // },
            {
            Header: "Actions",
            accessor: "actions",
            sortable: false,
            width: 150
            // filterable: false
            }
        ]}
        defaultPageSize={10}
        showPaginationTop={false}
        showPaginationBottom={true}
        className="-highlight"
        />
      ) : (
        <div className="h-100 text-center">
          {/* <h3 className="font-weight-bold">Create a new package / sub</h3>
          <p>Get started now</p>
          <NewOfferingButton {...props}/> */}

        </div>
      )}

  </div>
  )
}


function OnDemandPage(props) {

  const { history, match } = props;
  const dispatch = useDispatch();
  const partner = useSelector(state => state.instructor.instructor);
  const partnerId = partner?.platformID
  // useSelector(state => state.instructor.instructor.platformID);
  
  useEffect(() => {
    // dispatch
    if(partnerId) {
      dispatch(loadProducts())
    }
    
  }, [dispatch, partnerId]);

  
  

  // useEffect(() => {
  //   // dispatch
  //   console.log("new offerings")
  //   console.log(offerings)
    
  // }, [offerings]);

 


  function Products() {

    const shareLink = "https://sutrapro.com/" + (partner?.widgetName ?? "") + "/on-demand"
    return (
    <div className="container px-0">

      <Helmet>
        <title>On Demand Videos</title>
      </Helmet>
      <section>
        <div className='d-flex d-row justify-content-between align-items-center mb-4'>
          <h2 className="font-weight-bold">On Demand</h2>
          <div>
            <NewProductButton productType="ondemand" className="w-100" {...props} />
            <a className="w-100" href={shareLink} target="_blank">
              <button type="button" className="px-0 btn btn-link">Preview page</button>
            </a>
          </div>
        </div>
        <p><big>You can sell any piece of content a-la-carte or add the entire library to a subscription.</big></p>
        <div className="d-flex align-items-baseline">
          <h4 className="font-weight-bold mr-2">Share Library</h4>
          <div className="d-flex d-row align-items-center">
              
              <input
              style={{paddingRight: "50px"}}
              type="text" value={shareLink} readOnly={true} className={"form-control"}/>
              <ShareButton link={shareLink} 
              style={{marginLeft: "-50px"}}
              />
          </div>
        </div>
        <div className="d-flex align-items-baseline">
          
          <button className="btn btn-link p-0" onClick={() => history.push("/dashboard/settings#public-page")}>
            <h5 className="font-weight-bold primaryColor p-0">Embed in your website</h5>
          </button>
        </div>
        <ProductsTable
          {...props}
          history={history}
          baseUrl={match.url}
          // data={offerings}
          />
      </section>
    </div>
    );
  }

  return (
    <Switch>
        <Route path="/">
          <Products />
        </Route>
    </Switch>
  );
}

export default OnDemandPage;
